import Playtime from '../Playtime'
import NewWaysToConnect from '../NewWaysToConnect'

import './index.css'

const FeaturesSection = () => (
  <div className="features-section-container">
    <Playtime />
    <NewWaysToConnect />
  </div>
)

export default FeaturesSection
